<template>
    <div class="container my-5 py-5">
        <div class="row mb-2" v-if="responseStatus === 422 && loginAttempts">
          <div class="col col-lg-6 col-md-8 col-sm-12 offset-lg-3 offset-md-2 offset-sm-0" >
            <div class="card bg-warning mx-auto my-auto" >
              <div class="card-body text-white">
                <p><strong>WRONG CREDENTIALS</strong></p>
                <p>You have inputted wrong credentials</p>
                <p>Attempt(s) Remaining: <strong>{{loginAttempts}}</strong></p>
                <p><strong>WARNING:</strong> After <strong>5 consecutive</strong> unsuccessful login attempts, your account will be locked</p>
              </div>
            </div>

          </div>
        </div>
        <div class="row mb-2" v-if="responseStatus === 404">
          <div class="col col-lg-6 col-md-8 col-sm-12 offset-lg-3 offset-md-2 offset-sm-0" >
            <div class="card bg-danger mx-auto my-auto" >
              <div class="card-body text-white">
                <p><strong>ACCOUNT NOT FOUND</strong></p>
                <p>The username that you've entered doesn't match any account.</p>
                <p>Please ensure the username is valid
                or you can contact through <a href="mailto:krbshelpdesk@elitesdsi.com" class="text-white">krbshelpdesk@elitesdsi.com</a>
                </p>
              </div>
            </div>

          </div>
        </div>
<!--        <div class="row mb-2" v-else-if="secondsLeft !== null">-->
<!--          <div class="col col-lg-6 col-md-8 col-sm-12 offset-lg-3 offset-md-2 offset-sm-0">-->
<!--            <div class="card bg-danger mx-auto my-auto">-->
<!--              <div class="card-body text-white">-->
<!--                <p>LOGIN TEMPORARILY DISABLED</p>-->
<!--                <p>Too many incorrect Login / Password</p>-->
<!--                 Please wait <strong>{{secondsLeft}}</strong> seconds to login again-->
<!--              </div>-->
<!--            </div>-->

<!--          </div>-->
<!--        </div>-->
        <div class="row mb-2" v-else-if="responseStatus===429">
          <div class="col col-lg-6 col-md-8 col-sm-12 offset-lg-3 offset-md-2 offset-sm-0">
            <div class="card bg-danger mx-auto my-auto">
              <div class="card-body text-white">
                <p><strong>ACCOUNT LOCKED</strong></p>
                <p>You’ve reached the maximum login attempts. This account will be locked out immediately.</p>
                <p>Please contact <a href="mailto:krbshelpdesk@elitesdsi.com" class="text-white">krbshelpdesk@elitesdsi.com</a> to unlock it</p>
              </div>
            </div>
          </div>
        </div>
      <div class="row mb-2" v-else-if="responseStatus === 403 && !alreadyLocked">
        <div class="col col-lg-6 col-md-8 col-sm-12 offset-lg-3 offset-md-2 offset-sm-0">
          <div class="card bg-danger mx-auto my-auto">
            <div class="card-body text-white">
              <p>ACCOUNT DOES NOT HAVE ACCESS!</p>
              <p>This account does not have access to CMS</p>
               Please contact <a href="mailto:krbshelpdesk@elitesdsi.com" class="text-white">krbshelpdesk@elitesdsi.com</a> for assistance.
            </div>
          </div>
        </div>
       </div>
      <div class="row mb-2" v-else-if="responseStatus === 403 && alreadyLocked">
        <div class="col col-lg-6 col-md-8 col-sm-12 offset-lg-3 offset-md-2 offset-sm-0">
          <div class="card bg-danger mx-auto my-auto">
            <div class="card-body text-white">
              <p>ACCOUNT LOCKED!</p>
              <p>It looks like you're trying to log-in a locked account.</p>
              <p>Please contact <a href="mailto:krbshelpdesk@elitesdsi.com" class="text-white">krbshelpdesk@elitesdsi.com</a> to unlock it</p>
            </div>
          </div>
        </div>
      </div>
        <div class="row">
            <div class="col col-lg-6 col-md-8 col-sm-12 offset-lg-3 offset-md-2 offset-sm-0">
                <div class="card mx-auto my-auto">

                    <div class="card-header p-1">
                        <img src="../assets/logo.png" alt="KRBS LOGO" class="logo-header">
                    </div>

                    <form class="card-body" @submit.prevent="login">
                        <div class="form-group form-row">
                            <label class="col col-sm-3 col-form-label font-weight-bolder text-right"
                                   :class="{'text-danger':loginAttemptErrors.username}"
                                   for="username" >Username:
                            </label>
                            <div class="col col-sm-9">
                                <input type="text" id="username"
                                       required placeholder="Enter your Username"
                                       class="form-control"
                                       v-model="username"
                                >
                              <p class="text-danger text-left font-weight-bold" v-if="loginAttemptErrors.username">{{loginAttemptErrors.username.join('')}}</p>
                            </div>
                        </div>

                        <div class="form-group form-row">
                            <label class="col col-sm-3 col-form-label font-weight-bolder text-right"
                                    for="password" :class="{'text-danger':loginAttemptErrors.password}">Password:
                            </label>
                            <div class="col col-sm-9">
                              <div class="input-group">
                                <input type="password" id="password"
                                       required placeholder="Enter your Password"
                                       class="form-control"
                                       v-model="password"
                                >
                                <div class="input-group-append">
                                  <button class="btn btn-secondary" type="button" title="Show Password" @click="showPassword">
                                    <i class="fa fa-eye-slash" aria-hidden="true" id="xicon"></i>
                                  </button>
                                </div>
                              </div>
                              <p class="text-danger text-left font-weight-bold" v-if="loginAttemptErrors.password">{{loginAttemptErrors.password.join('')}}</p>
                            </div>
                        </div>

                        <button type="submit" class="btn btn-block login-button" :disabled="secondsLeft">
                            Login
                        </button>

                    </form>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import { vueAppMixin } from "../mixins/vueAppMixin";
    import {isNull} from "lodash";
    let timerBouncer=null
    export default {
        name: "Login",
        mixins: [ vueAppMixin ],
        data() {
            return {
                username: '',
                password: '',
                loginAttempts:null,
                disableLogin:false,
                secondsLeft:null,
                title:'',
                hasNoAccess:false,
                responseStatus:null,
                alreadyLocked:null,
                loginAttemptErrors:{
                  username:null,
                  password:null,
                }
            };
        },

        methods: {
            ...mapActions([ 'authenticate', 'setManningId', 'getSystemManual', 'getAdminAnnouncement' ]),

            async decrementLoginDisable(){
              this.secondsLeft=localStorage.getItem('lockedOutSeconds') - new Date;
              this.secondsLeft = Math.floor(this.secondsLeft / 1000)
              if(this.secondsLeft <= 0){
                this.secondsLeft=null;
                localStorage.removeItem('lockedOutSeconds');
                this.disableLogin=false;
              }
              else {
                // const secondsRemaining=this.secondsLeft - 1;
                // localStorage.setItem('lockedOutSeconds', secondsRemaining.toString())
                this.disableLogin=true
                setTimeout(()=>{
                  this.decrementLoginDisable()
                },1000)
              }
            },
            async login() {
                this.loading();
                const attempt=await this.authenticate({ username: this.username, password: this.password})
                if(typeof attempt === 'boolean' && attempt) {
                    this.welcome();
                    // // todo uncomment when has new changes
                    // await this.getSystemManual();
                    // let systemManualFile = 'data:application/pdf;base64,'+this.systemManual;
                    // this.systemUpdateModal(systemManualFile);

                  await this.getAdminAnnouncement();
                  let announcementData = [];
                  this.adminAnnouncementList.forEach((value,index ) => {
                    announcementData.push(value);
                  });
                    if(this.user.manning_id) {
                        this.setManningId(this.user.manning_id);
                      // execute if announcement list has record and duration is not yet finished
                      if(announcementData.length && announcementData[0].between_start_end_announcement == true){
                        this.$router.push({name: 'CrewIndex', params: { announcementModalId: '#view-admin-announcement-modal'} });
                      }else{
                        this.$router.push({name: 'CrewIndex', params: { announcementModalId: ''} });
                      }
                    } else {
                      // if announcementData[0].between_start_end_announcement is false then duration is finished
                      if(announcementData.length && announcementData[0].between_start_end_announcement == true){
                        this.$router.push({name: 'Principal', params: { announcementModalId: '#view-admin-announcement-modal'} });
                      }
                      else {
                        this.$router.push({name: 'Principal', params: { announcementModalId: ''} });
                      }
                    }
                }
                else{
                  this.responseStatus=attempt?.response.status;
                  this.loginAttempts=attempt?.response?.data?.attemptsLeft ?? null
                  this.hasNoAccess=attempt?.response?.data?.hasNoAccess ?? null
                  this.alreadyLocked=attempt?.response?.data?.alreadyLocked ?? null
                  const minutesLeft=attempt?.response?.data?.minutesLeft ?? 0
                  const message=attempt?.response?.data?.message
                  const errors = attempt?.response?.data?.errors;
                  // const title= !isNull(this.loginAttempts) ? 'LOGIN ATTEMPT' :
                  //     minutesLeft ? 'LOGIN DISABLED IN 2 MINUTES' : this.hasNoAccess ? 'Account has no access' : 'Account Locked'
                  const title= !isNull(this.loginAttempts) ? 'LOGIN ATTEMPT' :
                           this.hasNoAccess ? 'ACCOUNT HAS NO ACCESS' :
                           errors ? 'VALIDATION ERROR' :
                           this.responseStatus===404 ? 'ACCOUNT NOT FOUND' :
                           'ACCOUNT LOCKED';

                  this.loginAttemptErrors= errors ?? {username:null, password:null}
                  this.title=title;

                  // if(minutesLeft){
                  //   const timeUntil = +new Date + minutesLeft
                  //   localStorage.setItem('lockedOutSeconds',timeUntil);
                  //    this.decrementLoginDisable()
                  // }

                  swal.fire({
                    title:title,
                    confirmButtonColor:'#FF0000',
                    html: `<h4>${message}</h4>`
                  })
                 }
            },
            showPassword() {
                const passInput = document.getElementById('password');
                const x = document.getElementById('xicon');
                if (passInput.type === 'password') {
                  passInput.type = 'text';
                    x.setAttribute('class', 'fa fa-eye');
                } else {
                  passInput.type = 'password';
                    x.setAttribute('class', 'fa fa-eye-slash');
                }
            },
        },

        computed: {
            ...mapGetters([ 'user', 'systemManual', 'adminAnnouncementList' ])
        },

        mounted() {
            document.getElementById('username').focus();
        },
         created(){
              this.decrementLoginDisable()
        }
    }
</script>

<style scoped>

    .logo-header {
        width: 100%;
    }

    .login-button {
        background: #FF0000;
        color: white;
        font-family: 'Segoe UI', Helvetica, sans-serif;
        font-weight: bold;
    }

</style>
